import * as types from "./actionType";

const initialState = {
  dealerStatus: false,
  dealers: [],
  dealerCount: 0,
  dealerCountryStatus: false,
  countries: [],
  stateStatus: false,
  states: [],
  cityStatus: false,
  cities: [],
  searchFilter: false,
  userFilterStatus: true,
  allUserStatus: false,
  allUser: [],
  singleUserStatus: false,
  singleUser: null,
  onBoardingStatus: false,
  createUserStatus: false,
  countryMobileCodeStatus: false,
  countryMobileCode: [],
  motorCycleStatus: false,
  motorCycle: [],
  countryStatus: false,
  country: [],
  countryJsonMobileCodeStatus: false,
  countryJsonMobileCode: [],
  motorCycleCountryStatus: false,
  motorCycleCountry: [],
  vechicleOnboardingStatus: false,
  vechicleDetailStatus: false,
  vechicleDetail: null,
  ridersRegisterStatus: false,
  registerConsentForm: false,
  onBoardedUserStatus: false,
  onBoardedUserCount: 0,
  onBoardedUser: [],
  onBoardedUserDetailStatus: false,
  onBoardedUserDetail: null,
  preRegisteredUserStatus: false,
  preRegisteredUser: [],
  preRegisteredUserCount: 0,
  exportToExcelStatus: false,

  userVehiclesStatus: false,
  userVehicles: [],
  vehicleOnBoardingFromMembership: false,
};

function userReducer(state = initialState, action) {
  switch (action.type) {
    case types.SEARCH_FILTER_FOR_USER:
      return {
        ...state,
        searchFilter: true,
      };

    case types.CLEAR_PREVIOUS_REDUCERS:
      return {
        ...state,
        allUserStatus: false,
        allUser: [],
        userFilterStatus: true,
        preRegisteredUser: [],
        preRegisteredUserCount: 0,
        onBoardedUser: [],
        vechicleDetail: null,
        onBoardedUserCount: 0,
        searchFilter: false,
      };
    case types.FETCH_ALL_USERS:
      return {
        ...state,
        allUserStatus: true,
        allUser: [],
        userFilterStatus: true,
      };
    case types.FETCH_ALL_USERS_SUCCESS: {
      return {
        ...state,
        allUserStatus: false,
        allUser: action.payload,
        userFilterStatus: true,
      };
    }
    case types.FETCH_ALL_USERS_FAILED: {
      return {
        ...state,
        allUserStatus: false,
        allUser: [],
        userFilterStatus: false,
      };
    }

    case types.FETCH_SINGLE_USER:
      return {
        ...state,
        singleUserStatus: true,
        singleUser: null,
      };
    case types.FETCH_SINGLE_USER_SUCCESS: {
      return {
        ...state,
        singleUserStatus: false,
        singleUser: action.payload,
      };
    }
    case types.FETCH_SINGLE_USER_FAILED: {
      return {
        ...state,
        singleUserStatus: false,
        singleUser: null,
      };
    }

    case types.USER_ON_BOARDING:
      return {
        ...state,
        onBoardingStatus: true,
      };
    case types.USER_ON_BOARDING_SUCCESS: {
      return {
        ...state,
        onBoardingStatus: false,
      };
    }
    case types.USER_ON_BOARDING_FAILED: {
      return {
        ...state,
        onBoardingStatus: false,
      };
    }

    case types.CREATE_USER:
      return {
        ...state,
        createUserStatus: true,
      };
    case types.CREATE_USER_SUCCESS: {
      return {
        ...state,
        createUserStatus: false,
      };
    }
    case types.CREATE_USER_FAILED: {
      return {
        ...state,
        createUserStatus: false,
      };
    }

    case types.REGISTER_CONSENT_FORM:
      return {
        ...state,
        registerConsentForm: true,
      };
    case types.REGISTER_CONSENT_FORM_SUCCESS: {
      return {
        ...state,
        registerConsentForm: false,
      };
    }
    case types.REGISTER_CONSENT_FORM_FAILED: {
      return {
        ...state,
        registerConsentForm: false,
      };
    }

    case types.FETCH_USER_COUNTRY:
      return {
        ...state,
        countryStatus: true,
        country: [],
      };
    case types.FETCH_USER_COUNTRY_SUCCESS: {
      return {
        ...state,
        countryStatus: false,
        country: action.payload,
      };
    }
    case types.FETCH_USER_COUNTRY_FAILED: {
      return {
        ...state,
        countryStatus: false,
        country: [],
      };
    }

    case types.FETCH_USER_COUNTRY_MOBILE_CODE:
      return {
        ...state,
        countryMobileCodeStatus: true,
        countryMobileCode: [],
      };
    case types.FETCH_USER_COUNTRY_MOBILE_CODE_SUCCESS: {
      return {
        ...state,
        countryMobileCodeStatus: false,
        countryMobileCode: action.payload,
      };
    }
    case types.FETCH_USER_COUNTRY_MOBILE_CODE_FAILED: {
      return {
        ...state,
        countryMobileCodeStatus: false,
        countryMobileCode: [],
      };
    }
    case types.FETCH_USER_COUNTRY_JSON_MOBILE_CODE:
      return {
        ...state,
        countryJsonMobileCodeStatus: true,
        countryJsonMobileCode: [],
      };
    case types.FETCH_USER_COUNTRY_JSON_MOBILE_CODE_SUCCESS: {
      return {
        ...state,
        countryJsonMobileCodeStatus: false,
        countryJsonMobileCode: action.payload,
      };
    }
    case types.FETCH_USER_COUNTRY_JSON_MOBILE_CODE_FAILED: {
      return {
        ...state,
        countryJsonMobileCodeStatus: false,
        countryJsonMobileCode: [],
      };
    }
    case types.FETCH_MOTORCYCLE:
      return {
        ...state,
        motorCycleStatus: true,
        motorCycle: [],
      };
    case types.FETCH_MOTORCYCLE_SUCCESS: {
      return {
        ...state,
        motorCycleStatus: false,
        motorCycle: action.payload,
      };
    }
    case types.FETCH_MOTORCYCLE_FAILED: {
      return {
        ...state,
        motorCycleStatus: false,
        motorCycle: [],
      };
    }

    case types.FETCH_MOTOR_CYCLE_COUNTRY:
      return {
        ...state,
        motorCycleCountryStatus: true,
        motorCycleCountry: [],
      };
    case types.FETCH_MOTOR_CYCLE_COUNTRY_SUCCESS: {
      return {
        ...state,
        motorCycleCountryStatus: false,
        motorCycleCountry: action.payload,
      };
    }
    case types.FETCH_MOTOR_CYCLE_COUNTRY_FAILED: {
      return {
        ...state,
        motorCycleCountryStatus: false,
        motorCycleCountry: [],
      };
    }

    case types.VECHICLE_ONBOARDING:
      return {
        ...state,
        vechicleOnboardingStatus: true,
      };
    case types.VECHICLE_ONBOARDING_SUCCESS: {
      return {
        ...state,
        vechicleOnboardingStatus: false,
      };
    }
    case types.VECHICLE_ONBOARDING_FAILED: {
      return {
        ...state,
        vechicleOnboardingStatus: false,
      };
    }

    case types.VECHICLE_DETAILS:
      return {
        ...state,
        vechicleDetailStatus: false,
        vechicleDetail: null,
      };
    case types.VECHICLE_DETAILS_SUCCESS: {
      return {
        ...state,
        vechicleDetailStatus: false,
        vechicleDetail: action.payload,
      };
    }
    case types.VECHICLE_DETAILS_FAILED: {
      return {
        ...state,
        vechicleDetailStatus: false,
        vechicleDetail: null,
      };
    }
    case types.RIDERS_REGISTER:
      return {
        ...state,
        ridersRegisterStatus: true,
      };
    case types.RIDERS_REGISTER_SUCCESS: {
      return {
        ...state,
        ridersRegisterStatus: false,
      };
    }
    case types.RIDERS_REGISTER_FAILED: {
      return {
        ...state,
        ridersRegisterStatus: false,
      };
    }

    case types.FETCH_ONBOARD_USERS:
      return {
        ...state,
        onBoardedUserStatus: true,
      };
    case types.FETCH_ONBOARD_USERS_SUCCESS: {
      return {
        ...state,
        onBoardedUserStatus: false,
        onBoardedUser: [...state.onBoardedUser, ...action.payload],
        onBoardedUserCount: action.count,
      };
    }
    case types.FETCH_ONBOARD_USERS_FAILED: {
      return {
        ...state,
        onBoardedUserStatus: false,
        onBoardedUser: [],
      };
    }
    case types.ONBOARD_USERS_DETAIL:
      return {
        ...state,
        onBoardedUserDetailStatus: true,
        onBoardedUserDetail: null,
      };
    case types.ONBOARD_USERS_DETAIL_SUCCESS: {
      return {
        ...state,
        onBoardedUserDetailStatus: false,
        onBoardedUserDetail: action.payload,
      };
    }
    case types.ONBOARD_USERS_DETAIL_FAILED: {
      return {
        ...state,
        onBoardedUserDetailStatus: false,
        onBoardedUserDetail: null,
      };
    }

    case types.FETCH_PRE_REGISTER_USER:
      return {
        ...state,
        preRegisteredUserStatus: true,
      };
    case types.FETCH_PRE_REGISTER_USER_SUCCESS: {
      return {
        ...state,
        preRegisteredUserStatus: false,
        preRegisteredUser: [...state.preRegisteredUser, ...action.payload],
        preRegisteredUserCount: action.count,
      };
    }
    case types.FETCH_PRE_REGISTER_USER_FAILED: {
      return {
        ...state,
        preRegisteredUserStatus: false,
        preRegisteredUser: [],
      };
    }

    case types.EXPORT_TO_EXCEL:
      return {
        ...state,
        exportToExcelStatus: true,
      };
    case types.EXPORT_TO_EXCEL_SUCCESS: {
      return {
        ...state,
        exportToExcelStatus: false,
      };
    }
    case types.EXPORT_TO_EXCEL_FAILED: {
      return {
        ...state,
        exportToExcelStatus: false,
      };
    }

    case types.FETCH_USER_VEHICLES:
      return {
        ...state,
        userVehiclesStatus: true,
        userVehicles: [],
      };

    case types.FETCH_USER_VEHICLES_SUCCESS:
      return {
        ...state,
        userVehiclesStatus: false,
        userVehicles: action.payload,
      };

    case types.FETCH_USER_VEHICLES_FAILED:
      return {
        ...state,
        userVehiclesStatus: false,
        userVehicles: [],
      };

    case types.VECHICLE_ONBOARDING_FROM_MEMBERSHIP:
      return {
        ...state,
        vehicleOnBoardingFromMembership: true,
      };

    case types.VECHICLE_ONBOARDING_FROM_MEMBERSHIP_SUCCESS:
      return {
        ...state,
        vehicleOnBoardingFromMembership: false,
      };

    case types.VECHICLE_ONBOARDING_FROM_MEMBERSHIP_FAILED:
      return {
        ...state,
        vehicleOnBoardingFromMembership: false,
      };

    case types.FETCH_ALL_DEALER:
      return {
        ...state,
        dealerStatus: true,
      };
    case types.FETCH_ALL_DEALER_SUCCESS: {
      return {
        ...state,
        dealerStatus: false,
        dealers: action.payload,
        dealerCount: action.count,
      };
    }
    case types.FETCH_ALL_DEALER_FAILED: {
      return {
        ...state,
        dealerStatus: false,
        dealers: [],
      };
    }

    case types.FETCH_COUNTRY:
      return {
        ...state,
        dealerCountryStatus: true,
        countries: [],
      };
    case types.FETCH_COUNTRY_SUCCESS: {
      return {
        ...state,
        dealerCountryStatus: false,
        countries: action.payload,
      };
    }
    case types.FETCH_COUNTRY_FAILED: {
      return {
        ...state,
        dealerCountryStatus: false,
        countries: [],
      };
    }

    case types.FETCH_STATE:
      return {
        ...state,
        stateStatus: true,
        states: [],
      };
    case types.FETCH_STATE_SUCCESS: {
      return {
        ...state,
        stateStatus: false,
        states: action.payload,
      };
    }
    case types.FETCH_STATE_FAILED: {
      return {
        ...state,
        stateStatus: false,
        states: [],
      };
    }

    case types.FETCH_CITY:
      return {
        ...state,
        cityStatus: true,
        cities: [],
      };
    case types.FETCH_CITY_SUCCESS: {
      return {
        ...state,
        cityStatus: false,
        cities: action.payload,
      };
    }
    case types.FETCH_CITY_FAILED: {
      return {
        ...state,
        cityStatus: false,
        cities: [],
      };
    }

    default:
      return state;
  }
}

export default userReducer;
